var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "57px",
    height: "56px",
    viewBox: "0 0 57 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Digital-Settlements",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-page---Go-to-Digital-settlements---insurance-widget-Copy",
    transform: "translate(-408, -1326)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(103, 1149)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Drop-Area/Default",
    transform: "translate(0, 145)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-+-Text",
    transform: "translate(202.4651, 32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(103.3172, 0)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "24pt-Bounding-Box",
    opacity: 0,
    fillRule: "nonzero",
    points: "0 0 56 0 56 56 0 56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.39,26.3433333 C27.2972933,25.4539997 28.749364,25.4539997 29.6566667,26.3433333 L36.6701944,33.3568693 C37.5776738,34.271816 37.5716165,35.7491893 36.6566652,36.6566693 L36.6431357,36.6701988 C35.728189,37.5776779 34.2508157,37.5716206 33.3433357,36.6566692 L30.3333357,33.623336 L30.3333357,46.6666693 C30.3333357,47.9553343 29.2886674,49.0000026 28.0000024,49.0000026 C26.7113374,49.0000026 25.6666693,47.9553343 25.6666691,46.6666693 L25.6666691,33.5066689 L22.6100024,36.4700023 C22.5327546,36.5558976 22.4492341,36.6359382 22.3601304,36.7094629 C21.3661654,37.5296413 19.8955121,37.3887593 19.0753337,36.3947966 C18.2551554,35.4008316 18.3960374,33.9301783 19.3900001,33.1099999 Z M23.4210199,7.68231317 C30.7277366,5.15342317 38.7010866,9.02661651 41.2299999,16.3333332 L41.606872,16.386316 C43.8599467,16.7407233 45.9628371,17.7484399 47.652654,19.2885313 C52.4148613,23.628788 52.756928,31.007768 48.4166713,35.7699846 L48.2913196,35.9019281 C47.8581666,36.3236427 47.2759407,36.5625465 46.6666713,36.563318 L46.4784858,36.5554489 C45.9793536,36.5143482 45.5047833,36.3134501 45.1266713,35.9799847 L45.1159174,35.970571 L45.1052214,35.9610917 C44.1434203,35.1034284 44.0590026,33.6284607 44.9166706,32.6666584 L45.1151435,32.4347943 C46.1445925,31.1777029 46.7067628,29.598492 46.6991719,27.9673481 C46.6811819,24.1013881 43.5326285,20.9820002 39.6666685,20.9999914 L39.5266685,20.9999914 C38.4002261,21.0227088 37.4184402,20.2372784 37.1933351,19.1333248 L37.130064,18.8450449 C36.2958707,15.3107444 33.4802914,12.570168 29.9039785,11.8439684 C24.8524052,10.8182117 19.9257655,14.0817517 18.9000019,19.133325 L18.8606376,19.2964667 C18.576356,20.3138 17.636789,21.0215713 16.5666688,20.9999904 L16.3333356,20.9999904 C14.6002523,20.9919264 12.9257916,21.6270667 11.6340256,22.7824914 C8.75252227,25.3598681 8.50596827,29.7851514 11.0833449,32.6666547 L11.2142328,32.7812952 C11.3827538,32.9403845 11.5268745,33.1239241 11.6416113,33.3260244 C12.2778343,34.4466964 11.8851203,35.8709304 10.7644599,36.5071511 C9.64378793,37.1433741 8.21955393,36.7506601 7.58333326,35.6299997 L7.33247894,35.3370215 C5.94014612,33.6554091 5.0458665,31.6144974 4.75535665,29.4454998 C3.90000332,23.0592132 8.38371332,17.1886935 14.77,16.3333332 L14.8947266,15.9876745 C16.3573393,12.0948101 19.4791959,9.04660171 23.4210199,7.68231317 Z",
    id: "Fill",
    fill: "#D14200"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.dc407c7ccd2f22741d13d5c49c21f3e2.svg";
export { ForwardRef as ReactComponent };